function cacheVersionForPath(site, path) {
  const url = new URL(path || '/', 'http://spache.local');
  const siteVersion = Number(site.cacheVersion || 0);
  const routeVersion = Number(site.routeCacheVersions?.[url.pathname] || 0);

  return Math.max(siteVersion, routeVersion);
}

function nextSiteCacheVersion(site, now = Date.now()) {
  let version = Math.max(now, Number(site.cacheVersion || 0) + 1);
  for (const routeVersion of Object.values(site.routeCacheVersions || {})) {
    version = Math.max(version, Number(routeVersion) + 1);
  }
  return version;
}

function nextRouteCacheVersion(site, path, now = Date.now()) {
  return Math.max(now, cacheVersionForPath(site, path) + 1);
}

module.exports = { cacheVersionForPath, nextSiteCacheVersion, nextRouteCacheVersion };
